export default interface IDefinition {
  id: string | undefined;
}
